<template>
  <v-navigation-drawer
    v-model="sideBarDrawer"
    app
    class="p-4"
    v-if="$route && $route.name !== 'Login'"
  >
    <v-list>
      <v-list-item
        class="d-flex flex-row"
        v-for="route in routes"
        :key="route.path"
        @click="toggleSideBar"
      >
        <div class="d-flex">
          <router-link
            :to="route.path"
            style="color: black !important"
            class="d-flex text--black text-decoration-none"
          >
            <v-list-item-icon>
              <v-icon color="primary"> {{ route.icon }} </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <div class="text--black text-decoration-none">
                  {{ route.text }}
                </div>
              </v-list-item-title>
            </v-list-item-content>
          </router-link>
        </div>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "SideBar",
  setup() {
    const store = useStore();

    // Computed property for v-model binding
    const sideBarDrawer = computed({
      get() {
        return store.state.sideBarDrawer;
      },
      set(value) {
        store.commit("TOGGLE_SIDEBAR_DRAWER", value);
      },
    });

    // Method to toggle sidebar
    const toggleSideBar = () => {
      store.commit("TOGGLE_SIDEBAR_DRAWER");
    };

    return {
      sideBarDrawer,
      toggleSideBar,
    };
  },
  data() {
    return {
      drawer: true,
      routes: [
        {
          path: "/abstract-campaign",
          text: "Campaigns",
          icon: "mdi-atom",
        },
        // {
        //   path: "/engagement",
        //   text: "Engagement",
        //   icon: "mdi-abacus",
        // },

        {
          path: "/CFManager",
          text: "Slice Explorer",
          icon: "mdi-poll",
        },
        {
          path: "/cost-items",
          text: "Cost Items",
          icon: "mdi-alarm-panel",
        },
        {
          path: "/finnegans-product-mapping",
          text: "Finnegans Mappings",
          icon: "mdi-swap-horizontal",
        },
      ],
    };
  },
};
</script>
